import axios from 'axios';

// Criar instância específica para customer (não usar a API centralizada para evitar conflitos)
const baseURL =  import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000';

const customerApi = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para adicionar token de customer
customerApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('customer_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Interceptor para tratar erros de autenticação
customerApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      // Clear customer storage
      localStorage.removeItem('customer_token');
      localStorage.removeItem('customer_auth');
      
      // Redirecionar para login de customer
      if (!window.location.pathname.startsWith('/customer/login')) {
        window.location.href = '/customer/login';
      }
    }
    return Promise.reject(error);
  }
);

export const customerAuthService = {
  login: (cpf: string, password: string) =>
    customerApi.post('/users/customer/login', { cpf, password }),

  getProfile: () =>
    customerApi.get('/users/customer/profile'),
};